import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";

const TONE = { primary: "bg-primary/15 text-primary", amber: "bg-amber-400/15 text-amber-300", muted: "bg-foreground/[0.06] text-muted-foreground" };

// Public and auth pages always use the dark HireStream theme, whatever the visitor's app setting.
export function PublicPage({ className, children, ...props }) {
  return <div className={cn("dark min-h-dvh bg-background text-foreground", className)} {...props}>{children}</div>;
}

export function LogoMark({ logo, className }) {
  if (logo) return <img src={logo} alt="" className={cn("h-8 w-8 rounded-[9px] object-cover shrink-0", className)} />;
  return <span className={cn("h-8 w-8 rounded-[9px] bg-gradient-to-br from-primary to-teal-600 flex items-center justify-center text-primary-foreground shrink-0", className)}><Sparkles className="h-4 w-4" /></span>;
}

export function BrandMark({ to = "/", testId = "public-brand" }) {
  return (
    <Link to={to} className="flex items-center gap-2.5 shrink-0" data-testid={testId}>
      <LogoMark /><span className="font-display font-bold text-lg tracking-tight">HireStream</span>
    </Link>
  );
}

export function PublicHeader({ children, right, sticky = true }) {
  return (
    <header className={cn("z-40 h-16 border-b border-border/70 bg-background/85 backdrop-blur-xl", sticky && "sticky top-0")} data-testid="public-header">
      <div className="mx-auto max-w-[1360px] h-full px-4 sm:px-8 flex items-center gap-4 sm:gap-8 min-w-0">
        {children}
        <div className="ml-auto flex items-center gap-3 sm:gap-4 shrink-0">{right}</div>
      </div>
    </header>
  );
}

export function StatusCard({ icon: Icon, tone = "muted", title, children, actions, testId, className }) {
  return (
    <div className={cn("w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center space-y-5", className)} data-testid={testId}>
      <div className={cn("h-14 w-14 rounded-2xl mx-auto flex items-center justify-center", TONE[tone])}><Icon className="h-6 w-6" /></div>
      <div className="space-y-2">
        <h1 className="font-display text-2xl font-semibold tracking-tight">{title}</h1>
        <div className="text-sm text-muted-foreground leading-6">{children}</div>
      </div>
      {actions && <div className="flex flex-wrap justify-center gap-2.5">{actions}</div>}
    </div>
  );
}
